import {
	DatePicker,
	Form,
	Input,
	message,
	Radio,
	Select,
	Table,
	Upload,
	Spin,
} from "antd";
import Button from "atoms/Button";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { useSelector } from "react-redux";
import { getUserInfo, getUserList } from "redux/selectors";
import { UploadOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import { billingOffice, STATUS_CODE } from "common/Constants";
import { CALL_FEATCH_API } from "common/API";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { ViewClaims } from "./ViewClaims";
import BillingInvoice from "./BillingInvoice";
import userlogo from "../../../assets/bdo logo.svg";
import { useBilling } from "context/BillingContext";
import { ViewTimelogs } from "pages/Matter/ViewTimelogs";

const SubmitBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 22px;
  border-radius: 6px;
  font-size: 14px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.15s;
  border: none;
  background: ${({ disabled }) => (disabled ? "#a8f0d0" : "#00685F")};
  color: #ffffff;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
`;

const AddNewBilling = () => {
	const userList = useSelector((state) => getUserList(state));
	const [loading, setLoading] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [base64, setBase64] = useState("");
	const { getClaims } = queryKeys;
	const location = useLocation();
	const {
		record,
		viewbillings = false,
		tabid = "",
		dataList = [],
		matterId,
		matterData,
		source = "Matter",
		allBillingData = [],
	} = location.state || {};
	const engagementDataForDirectPreview =
		location.state?.engagementDataForDirectPreview || [];
	const [update] = useState(!!record);
	const [addClaims, setaddClaims] = useState([]);
	const [addTimelogs, setAddTimelogs] = useState([]);
	const [isViewClims, setIsViewClims] = useState(false);
	const [internalBillingChecked, setInternalBillingChecked] = useState(false);
	const [isPreviewVisible, setIsPreviewVisible] = useState(false);
	const [baseFeeAmount, setBaseFeeAmount] = useState(
		parseFloat(record?.billingfee || 0)
	);
	const [formValues, setFormValues] = useState({
		description: record?.description || "",
		amount: record?.amount || "",
		vat: record?.vat || "Non-VAT",
	});
	const [billingInvoiceDatass, setBillingInvoiceDatass] = useState({
		billingdate: moment(),
		loerefno: "Loading...",
		contactpersonid: "Loading...",
		contactpersonacid: "Loading...",
		address: "Loading...",
		emailaddress1: "Loading...",
		bdo_pin: "Loading...",
		claims: [],
	});

	const [isTimelogModalVisible, setIsTimelogModalVisible] = useState(false);
	const [isViewTimelogModal, setIsViewTimelogModal] = useState(false);
	const [timelogsDataSource, setTimelogsDataSource] = useState([]);
	const [form] = Form.useForm();
	const userInfo = useSelector((state) => getUserInfo(state));
	const history = useHistory();

	const resolvedMatterId = matterId || record?.matterid || matterData?.matterId || "N/A";

	const { addBill } = useBilling();

	// ── Ref for BillingInvoice print ──────────────────────────────
	const billingInvoiceRef = useRef(null);

	const isHourly = !!matterData && matterData?.billingMethod === "Hourly";
	const isHideTimelog =
		!!matterData &&
		(matterData?.billingMethod === "Flat Fee" ||
			matterData?.billingMethod === "Contingency Fee");

	const currentYear = new Date().getFullYear();
	const billingOfficeId = matterData?.billingOffice;
	const billingOfficeName = billingOffice.find(
		(o) => o.id === billingOfficeId
	)?.name;
	const matterName = matterData?.jobTitle || "Advisory Matter";

	const activeclaimsIds = [
		...new Set(
			allBillingData?.flatMap((item) =>
				item?.claims?.map((claim) => claim?.claimsId)
			)
		),
	];

	const activeTimelogIds = [
		...new Set(
			allBillingData
				?.flatMap((item) =>
					item?.timelog?.map((t) => t?.timelogId?.timelogid)
				)
				.filter(Boolean)
		),
	];

	const userListOptions = userList.map((user) => ({
		label: user.fullname,
		value: user.userid,
	}));

	const { key: claimskey, url: claimsurl } = getClaims(
		`?matterid=${matterData?.matterId}&clientId=${matterData?.clientId}&matterclaims=true`
	);

	const { data: getClaimsData } = useFetch(claimskey, claimsurl, {
		enabled: !!matterData?.matterId && !!matterData?.clientId,
	});
	const claimsDataSource = getClaimsData?.response?.data;

	const clientId = matterData?.clientId;
	const clientKey = ["getLegalClientById", clientId];
	const clientUrl = `insyts-legal/getlegalclientbyid?clientid=${clientId}`;

	const { data: clientDataRes, isLoading: clientLoading } = useFetch(
		clientKey,
		clientUrl,
		{ enabled: !!clientId }
	);

	const { data: billingentity } = useFetch(
		queryKeys.getBillingEntityList.key,
		queryKeys.getBillingEntityList.url
	);
	const taxRate =
		billingentity?.response?.data?.find(
			(be) =>
				be.id === matterData?.financial_resourcePlan?.billingEntityId
		)?.tax || 0;

	useEffect(() => {
		if (!matterData?.matterId) return;
		const fetchTimelogs = async () => {
			try {
				const res = await CALL_FEATCH_API(
					`insyts-matter/gettimelog?matterid=${matterData?.matterId}&mattertimelog=true`,
					"GET"
				);
				const data = res?.response?.data ?? res?.data ?? res ?? [];
				setTimelogsDataSource(Array.isArray(data) ? data : []);
			} catch (err) {
				console.error("Error fetching timelogs:", err);
			}
		};
		fetchTimelogs();
	}, [matterData?.matterId]);

	useEffect(() => {
		const client = clientDataRes?.response?.data;
		if (!client) return;

		const updatedData = {
			billingdate: moment(),
			currency: matterData?.financial_resourcePlan?.currency || "",
			loerefno: client?.bdo_id || "",
			contactpersonid: client?.primarycontactperson || "",
			contactpersonacid: client?.primarycontactperson || "",
			address: client?.registeredaddress || "",
			emailaddress1: client?.primarycontactemail || "",
			bdo_pin: client?.bdo_pin || "",
			clientname: client?.companyregisteredname || "",
			managingoffice: client?.managingoffice || "",
			claims: record?.claims || [],
			leadattorney: matterData?.leadAttorney,
			referringattorney: matterData?.referringAttorney,
			city: client?.city || "",
			state: client?.state || "",
			zipcode: client?.zipcode || "",
			country: client?.country || "",
		};

		setBillingInvoiceDatass(updatedData);
		form.setFieldsValue(updatedData);
	}, [clientDataRes]);

	useEffect(() => {
		setaddClaims(record?.claims);

		if (record?.timelog?.length > 0) {
			const unwrappedTimelogs = record.timelog.map((t) => {
				if (t?.timelogId && typeof t.timelogId === "object") {
					return { ...t.timelogId };
				}
				if (t && typeof t === "object") {
					return { ...t };
				}
				return t;
			});
			setAddTimelogs(unwrappedTimelogs);
		}
	}, []);

	const client = clientDataRes?.response?.data;

	const initialValues = record
		? {
			billingdate: record.billingdate
				? moment(record.billingdate)
				: moment(),
			internalbilling: record.internalbilling,
			description: record.description || "",
			currency: record.currency || "",
			amount: record?.billingfee || record?.amount || 0,
			vat: record.vat || "Non-VAT",
			financialyear: record.financialyear,
			loerefno: record.loerefno || "",
			contactpersonid: record.contactpersonid || "",
			contactpersonacid: record.contactpersonacid || "",
			file: record.billingfile
				? [{ name: record.billingfile.split("/").pop() }]
				: [],
			claims: record?.claims || [],
			matterId: resolvedMatterId,
		}
		: {
			billingdate: moment(),
			currency: matterData?.financial_resourcePlan?.currency || "",
			loerefno: client?.bdo_id || "",
			financialyear: currentYear,
			contactpersonid: client?.primarycontactperson || "",
			contactpersonacid: client?.primarycontactperson || "",
			address: client?.registeredaddress || "",
			emailaddress1: client?.primarycontactemail || "",
			claims: record?.claims || [],
			matterId: resolvedMatterId,
		};

	const handleInputChange = (e) => {
		if (!e || !e.target) return;
		const { name, value } = e.target;
		setFormValues((prev) => ({ ...prev, [name]: value }));
	};

	// ── Sync invoice data into state ────────────────────────────
	const syncInvoiceData = () => {
		const currentFormValues = form.getFieldsValue(true);
		setFormValues({
			description: currentFormValues?.description || "",
			amount: currentFormValues?.amount || "",
			vat: currentFormValues?.vat || "Non-VAT",
		});
		setBillingInvoiceDatass((prev) => ({
			...prev,
			...currentFormValues,
			claims: addClaims ?? [],
		}));
	};

	// ── Preview — opens the modal ────────────────────────────────
	const handlePreview = () => {
		syncInvoiceData();
		setIsPreviewVisible(true);
	};

	// ── Print — directly triggers print, no modal shown ─────────
	const handlePrint = () => {
		syncInvoiceData();
		// Small tick so state flush completes before printing
		setTimeout(() => {
			billingInvoiceRef.current?.handlePrint();
		}, 100);
	};

	const handleCloseInvoicePreviewModal = () => setIsPreviewVisible(false);

	useEffect(() => {
		if (!isHourly) return;

		const total = (addTimelogs || []).reduce((acc, t) => {
			const amt = parseFloat(t?.convertedamount || t?.totalamount || 0);
			return acc + (isNaN(amt) ? 0 : amt);
		}, 0);

		setBaseFeeAmount(total > 0 ? total : 0);
		form.setFieldsValue({ amount: total > 0 ? total : "" });
		setFormValues((prev) => ({
			...prev,
			amount: total > 0 ? String(total) : "",
		}));
	}, [addTimelogs, isHourly]);

	const onFinish = async (formData) => {
		try {
			setLoading(true);

			if (isHourly && (!addTimelogs || addTimelogs?.length === 0)) {
				message.error(
					"Please add at least one timelog before submitting."
				);
				setLoading(false);
				return;
			}

			if (isHourly) {
				const amt = parseFloat(formData?.amount);
				if (!amt || amt <= 0) {
					message.error(
						"Amount must be greater than 0. Please select timelogs."
					);
					setLoading(false);
					return;
				}
			}

			const vatRate =
				formData?.vat?.trim()?.toUpperCase() === "VAT"
					? Number(taxRate) / 100
					: 0;

			const feesAmount = baseFeeAmount || parseFloat(formData?.amount) || 0;

			const claimsTotal = (addClaims || []).reduce((sum, cl) => {
				const amount = parseFloat(cl?.amount || 0);
				if (cl?.taxtype !== "VAT") return sum + amount;
				return sum + amount;
			}, 0);

			const vatclaims = (addClaims || []).reduce((sum, cl) => {
				const amount = parseFloat(cl?.amount || 0);
				if (cl?.taxtype !== "VAT") return 0;
				return sum + amount * Number(taxRate) / 100;
			}, 0)

			const grandTotal =
				(formData?.vat?.trim()?.toUpperCase() === "VAT"
					? Number(feesAmount) + (Number(feesAmount) * vatRate)
					: Number(feesAmount)) + Number(claimsTotal) + Number(vatclaims);

			const claimsPayload = Array.isArray(addClaims)
				? addClaims.map((c) => {
					const taxtype =
						c?.taxtype ||
						(c?.vat === true
							? "VAT"
							: c?.non_vat === true
								? "Non-VAT"
								: "");
					return {
						claimsId: c?.claimsId || "",
						amount: c?.amount || "0",
						type: c?.type || "",
						currency: c?.currency || "",
						date: new Date(c?.date) || "",
						submittedby: c?.submittedby || "",
						taxtype,
						non_vat: taxtype === "Non-VAT",
						vat: taxtype === "VAT",
						description: c?.description || "",
						attachments: c?.attachments || [],
						remarks: c?.remarks || "",
						status: true,
					};
				})
				: [];

			const timelogsPayload = Array.isArray(addTimelogs)
				? addTimelogs.map((t) => ({
					timelogId: t?.timelogId || t?.id || t,
				}))
				: [];

			const payload = {
				clientcode: matterData?.clientId,
				matterid: matterData?.matterId,
				statusid: "1",
				statusname: "Pending",
				leadAttorney: matterData?.leadAttorney,
				referringAttorney: matterData?.referringAttorney,
				billingoffice: matterData?.financial_resourcePlan?.billingEntity,
				userid: userInfo?.userid,
				billingdate: moment(formData?.billingdate).format("YYYY-MM-DD"),
				internalbilling: formData?.internalbilling || false,
				description: formData?.description,
				currency: formData?.currency,
				amount: grandTotal,
				billingfee: feesAmount,
				tax: taxRate,
				claimstotal: claimsTotal,
				vat: formData?.vat,
				financialyear: moment(formData?.billingdate).format("YYYY-MM-DD"),
				loerefno: formData?.loerefno,
				contactpersonid: formData?.contactpersonid,
				contactperson: formData?.contactpersonid,
				contactpersonacid: formData?.contactpersonacid,
				contactpersonac: formData?.contactpersonacid,
				billingfilename: formData?.file?.[0]?.name || null,
				billingfiletype: formData?.file?.[0]?.type || null,
				content: base64 || "",
				billingfile: update ? record?.billingfile : "",
				matterName: matterData?.jobTitle,
				clientName: matterData?.clientName,
				managingoffice: matterData?.managingoffice || "",
				claims: claimsPayload,
				timelog: timelogsPayload,
			};

			const response = update
				? await CALL_FEATCH_API(
					`insyts/billing?matterid=${matterData?.matterId ?? record.matterid
					}&billingid=${record?.billingid}`,
					"patch",
					payload
				)
				: await CALL_FEATCH_API(`insyts/billing`, "post", payload);

			const billingRes = response?.response;

			if (response?.status === "SUCCESS" || billingRes?.code === "SUCCESS") {
				message.success(
					update ? "Bill updated successfully" : "Bill added successfully"
				);
				addBill({ billingRes });
				if (tabid === "billing_approval") {
					history.push("/approvals", { tabId: tabid });
				} else {
					history.push(`/matter-details/${matterData?.matterId}`, {
						activeTab: "billing",
						matterData: matterData,
					});
				}
			} else {
				message.error("Something went wrong. Please try again.");
			}
		} catch (error) {
			console.error("Billing submit error:", error);
			message.error(
				"Something went wrong. Please reach out to our technical team."
			);
		} finally {
			setLoading(false);
		}
	};

	const dataSource = [
		{
			key: 1,
			actionStatus: "Date",
			approvedbyPartner: (
				<>
					{viewbillings ? (
						<>
							{record?.billingdate
								? moment(record.billingdate).format("DD-MM-YYYY")
								: form.getFieldValue("billingdate")
									? moment(
										form.getFieldValue("billingdate")
									).format("DD-MM-YYYY")
									: ""}
						</>
					) : (
						<>
							<Form.Item
								name="billingdate"
								rules={[
									{
										required: true,
										message: "Please select Date!",
									},
								]}
							>
								<DatePicker
									format="DD-MM-YYYY"
									style={{ width: "100%" }}
									placeholder="Select"
									disabledDate={(current) =>
										current && current < moment().startOf("day")
									}
								/>
							</Form.Item>
							<Form.Item
								name="internalbilling"
								valuePropName="checked"
								style={{ marginTop: 0 }}
							>
								{/* <Checkbox onChange={handleCheckboxChange}>Internal Billing</Checkbox> */}
							</Form.Item>
							{/* {(form.getFieldValue("internalbilling") ||
								internalBillingChecked) && (
								<span style={{ color: "#52c41a", fontSize: 12 }}>
									This bill will not be sent to finance; it will be
									sent to the partner only.
								</span>
							)} */}
						</>
					)}
				</>
			),
		},
		{
			key: 2,
			actionStatus: "Description",
			approvedbyPartner: viewbillings ? (
				<>
					{form.getFieldValue("description") || record?.description}
				</>
			) : (
				<Form.Item
					name="description"
					rules={[
						{
							required: true,
							message: "Please input description!",
						},
					]}
				>
					<Input.TextArea
						name="description"
						value={formValues.description}
						onChange={handleInputChange}
						bordered={false}
						placeholder="Description"
						rows={2}
						style={{ resize: "none" }}
					/>
				</Form.Item>
			),
		},
		{
			key: 4,
			actionStatus: "Currency",
			approvedbyPartner: viewbillings ? (
				<>{form.getFieldValue("currency") || record?.currency}</>
			) : (
				<Form.Item
					name="currency"
					rules={[{ required: true, message: "Currency is required." }]}
				>
					<Input placeholder="Enter" disabled />
				</Form.Item>
			),
		},
		{
			key: 5,
			actionStatus: "Amount",
			approvedbyPartner: (
				<>
					{viewbillings ? (
						<>
							{form.getFieldValue("amount") || record?.amount}
							<br />
							{form.getFieldValue("vat") || record?.vat}
						</>
					) : (
						<Form.Item
							name="amount"
							rules={[
								{ required: true, message: "Amount is required." },
								() => ({
									validator(_, value) {
										if (!isHourly) return Promise.resolve();
										const numVal = parseFloat(value);
										if (!value || isNaN(numVal) || numVal <= 0) {
											if (
												!addTimelogs ||
												addTimelogs.length === 0
											) {
												return Promise.reject(
													new Error(
														"Please add at least one timelog before submitting."
													)
												);
											}
											return Promise.reject(
												new Error(
													"Amount must be greater than 0. Please select timelogs."
												)
											);
										}
										return Promise.resolve();
									},
								}),
							]}
						>
							<Input
								placeholder={
									isHourly
										? "Auto-calculated from timelogs"
										: "Enter"
								}
								name="amount"
								type="number"
								disabled={isHourly}
								onChange={(e) => {
									const value = e?.target?.value;
									if (!isHourly && value !== undefined) {
										const parsed = parseFloat(value) || 0;
										setBaseFeeAmount(parsed);
										setFormValues((prev) => ({
											...prev,
											amount: value,
										}));
									}
								}}
							/>
						</Form.Item>
					)}
					{!viewbillings && (
						<Form.Item name="vat" style={{ marginTop: 8 }}>
							<Radio.Group
								disabled={viewbillings}
								onChange={(e) =>
									setFormValues((prev) => ({
										...prev,
										vat: e.target.value,
									}))
								}
							>
								<Radio value="VAT">VAT</Radio>
								<Radio value="Non-VAT">Non-VAT</Radio>
							</Radio.Group>
						</Form.Item>
					)}
				</>
			),
		},
		{
			key: 6,
			actionStatus: "Financial Year",
			approvedbyPartner: viewbillings ? (
				<>{currentYear}</>
			) : (
				<Form.Item name="financialyear">
					<Input placeholder="Enter" disabled />
				</Form.Item>
			),
		},
		{
			key: 8,
			actionStatus: "Matter ID",
			approvedbyPartner: viewbillings ? (
				<>{resolvedMatterId}</>
			) : (
				<Form.Item name="matterId">
					<Input
						disabled
						placeholder="Enter"
						defaultValue={resolvedMatterId}
					/>
				</Form.Item>
			),
		},
		{
			key: 9,
			actionStatus: "Contact Person",
			approvedbyPartner: viewbillings ? (
				<>
					{userListOptions.find(
						(u) =>
							u.value ===
							(form.getFieldValue("contactpersonid") ||
								record?.contactpersonid)
					)?.label ||
						form.getFieldValue("contactpersonid") ||
						record?.contactpersonid}
				</>
			) : (
				<Form.Item
					name="contactpersonid"
					rules={[
						{
							required: true,
							message: "Please enter Contact Person!",
						},
					]}
				>
					<Select
						placeholder="Select"
						showSearch
						disabled
						filterOption={(input, option) =>
							(option?.label?.toLowerCase() ?? "").includes(
								input.toLowerCase()
							)
						}
						options={userListOptions}
					/>
				</Form.Item>
			),
		},
		{
			key: 10,
			actionStatus: "Contact Person A/C",
			approvedbyPartner: viewbillings ? (
				<>
					{userListOptions.find(
						(u) =>
							u.value ===
							(form.getFieldValue("contactpersonacid") ||
								record?.contactpersonacid)
					)?.label ||
						form.getFieldValue("contactpersonacid") ||
						record?.contactpersonacid}
				</>
			) : (
				<Form.Item
					name="contactpersonacid"
					rules={[
						{
							required: true,
							message: "Please enter Contact Person A/C",
						},
					]}
				>
					<Select
						placeholder="Select"
						showSearch
						disabled
						filterOption={(input, option) =>
							(option?.label?.toLowerCase() ?? "").includes(
								input.toLowerCase()
							)
						}
						options={userListOptions}
					/>
				</Form.Item>
			),
		},
		{
			key: 11,
			actionStatus: "File Name",
			approvedbyPartner: viewbillings ? (
				<>
					{record?.billingfile
						? new URL(record.billingfile).pathname.split("/").pop()
						: form.getFieldValue("file")?.[0]?.name || ""}
				</>
			) : (
				<Form.Item
					name="file"
					valuePropName="fileList"
					getValueFromEvent={(e) =>
						Array.isArray(e) ? e : e?.fileList
					}
				>
					<Upload
						showUploadList
						accept=".pdf,.docx,.ppt,.pptx"
						maxCount={1}
						beforeUpload={(file) => {
							const allowed = [
								"application/pdf",
								"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
								"application/vnd.ms-powerpoint",
								"application/vnd.openxmlformats-officedocument.presentationml.presentation",
							];
							if (!allowed.includes(file.type)) {
								message.error(
									"Only PDF, DOCX, and PPT files are allowed"
								);
								return Upload.LIST_IGNORE;
							}
							return true;
						}}
						customRequest={({ file, onSuccess }) => {
							const reader = new FileReader();
							reader.readAsDataURL(file);
							reader.onload = () => {
								setBase64(reader.result.split(",")[1]);
								onSuccess();
							};
						}}
					>
						<Button icon={<UploadOutlined />}>Click to Upload</Button>
					</Upload>
				</Form.Item>
			),
		},
		{
			key: 12,
			actionStatus: "Select Claims",
			approvedbyPartner: (
				<>
					<div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
						{(addClaims?.length > 0 || viewbillings) && (
							<StyledActionBtn
								type="button"
								onClick={() => setIsViewClims(true)}
							>
								View Claims
							</StyledActionBtn>
						)}
						{!viewbillings && (
							<StyledActionBtn
								type="button"
								$primary
								onClick={() => setIsModalVisible(true)}
							>
								Add Claims
							</StyledActionBtn>
						)}
					</div>

					<ViewClaims
						isModalVisible={isModalVisible || isViewClims}
						viewClims={isViewClims}
						setIsModalVisible={(val) => {
							setIsModalVisible(false);
							setIsViewClims(false);
						}}
						setaddClaims={setaddClaims}
						addClaims={addClaims}
						claimsDataSource={
							isViewClims ? addClaims : claimsDataSource
						}
						isViewClims={isViewClims}
						update={update || addClaims?.length > 0}
						activeclaimsIds={activeclaimsIds}
					/>
				</>
			),
		},
		...(!isHideTimelog
			? [
				{
					key: 13,
					actionStatus: "Select Timelog",
					approvedbyPartner: (
						<>
							<div
								style={{
									display: "flex",
									gap: 8,
									flexWrap: "wrap",
								}}
							>
								{(addTimelogs?.length > 0 || viewbillings) && (
									<StyledActionBtn
										type="button"
										onClick={() =>
											setIsViewTimelogModal(true)
										}
									>
										View Timelog
									</StyledActionBtn>
								)}
								{!viewbillings && (
									<StyledActionBtn
										type="button"
										$primary
										onClick={() =>
											setIsTimelogModalVisible(true)
										}
									>
										Add Timelog
									</StyledActionBtn>
								)}
							</div>

							<ViewTimelogs
								isModalVisible={
									isTimelogModalVisible || isViewTimelogModal
								}
								setIsModalVisible={(val) => {
									setIsTimelogModalVisible(false);
									setIsViewTimelogModal(false);
								}}
								addTimelogs={addTimelogs}
								setAddTimelogs={setAddTimelogs}
								viewTimelogs={isViewTimelogModal}
								timelogsDataSource={
									isViewTimelogModal
										? addTimelogs
										: timelogsDataSource
								}
								isViewTimelogs={isViewTimelogModal}
								update={update || addTimelogs?.length > 0}
								activeTimelogIds={activeTimelogIds}
								matterid={matterData?.matterId}
								userData={userList}
							/>
						</>
					),
				},
			]
			: []),
	];

	const columns = [
		{
			title: "Action/Status",
			dataIndex: "actionStatus",
			key: "actionStatus",
			width: "30%",
			className: "action-status-col",
		},
		{
			title:
				update || viewbillings
					? record?.statusname || "pending"
					: "pending",
			dataIndex: "approvedbyPartner",
			key: "approvedbyPartner",
			width: "70%",
		},
	];

	if (clientLoading) {
		return (
			<PageWrapper>
				<Spin
					spinning
					tip="Loading client details..."
					style={{
						display: "flex",
						justifyContent: "center",
						marginTop: 120,
					}}
				/>
			</PageWrapper>
		);
	}

	return (
		<PageWrapper>
			<Breadcrumb>
				<BreadcrumbItem onClick={() => history.goBack()} $clickable>
					{source}
				</BreadcrumbItem>
				<BreadcrumbSep>›</BreadcrumbSep>
				<BreadcrumbItem onClick={() => history.goBack()} $clickable>
					{matterName}
				</BreadcrumbItem>
				<BreadcrumbSep>›</BreadcrumbSep>
				<BreadcrumbItem>
					{update
						? viewbillings
							? "View Bill"
							: "Edit Bill"
						: "Adding Bill"}
				</BreadcrumbItem>
			</Breadcrumb>

			{/*
			  Always mounted so ref is available for silent printing.
			  open={isPreviewVisible} means the modal only appears for Preview.
			*/}
			<BillingInvoice
				ref={billingInvoiceRef}
				billingInvoiceData={billingInvoiceDatass}
				open={isPreviewVisible}
				engagementDataForDirectPreview={engagementDataForDirectPreview}
				handleClose={handleCloseInvoicePreviewModal}
				formValues={formValues}
				matterData={matterData}
				taxRate={taxRate}
				matterClientData={clientDataRes?.response?.data}
			/>

			<Form
				form={form}
				onFinish={onFinish}
				initialValues={initialValues}
				onValuesChange={(changedValues, allValues) => {
					setFormValues((prev) => ({
						...prev,
						...allValues,
					}));
				}}
			>
				<StyledTable
					columns={columns}
					dataSource={dataSource}
					pagination={false}
					bordered={false}
				/>

				<FooterBar>
					<FooterBtn
						type="button"
						onClick={() => {
							if (tabid) history.push("/approvals", { tabId: tabid });
							else history.goBack();
						}}
					>
						Cancel
					</FooterBtn>
					{!viewbillings && (
						<>
							{/* Print Invoice — opens preview modal then triggers
							    BillingInvoice's own useReactToPrint, so output
							    is pixel-identical to the preview. */}
							<FooterBtn type="button" onClick={handlePrint}>
								Print Invoice
							</FooterBtn>
							<FooterBtn type="button" onClick={handlePreview}>
								Preview
							</FooterBtn>
							<SubmitBtn type="submit" disabled={loading}>
								{loading
									? update
										? "Updating..."
										: "Submitting..."
									: update
										? "Update"
										: "Submit"}
							</SubmitBtn>
						</>
					)}
				</FooterBar>
			</Form>
		</PageWrapper>
	);
};

export default AddNewBilling;

// ── Styled Components ─────────────────────────────────────────────

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #ffffff;
  font-family: "Segoe UI", sans-serif;
  /* padding-bottom removed — no longer needed, footer isn't fixed */
  .ant-form-item { margin-bottom: 0 !important; }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #02b209 !important;
    border-color: #02b209 !important;
  }
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 16px 24px 12px;
  font-size: 14px;
  color: #555;
`;

const BreadcrumbItem = styled.span`
  color: ${({ $clickable }) => ($clickable ? "#555" : "#111")};
  font-weight: ${({ $clickable }) => ($clickable ? 400 : 600)};
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
  &:hover { text-decoration: ${({ $clickable }) => ($clickable ? "underline" : "none")}; }
`;

const BreadcrumbSep = styled.span`
  color: #aaa;
  font-size: 16px;
`;

const StyledTable = styled(Table)`
  .ant-table { border: 1px solid #e0e0e0; border-radius: 0; }
  .ant-table-thead > tr > th {
    background: #f7f7f8 !important;
    color: #333;
    font-weight: 600;
    font-size: 14px;
    border-bottom: 1px solid #dbdbdb;
    padding: 12px 16px;
  }
  .ant-table-tbody > tr > td {
    padding: 12px 16px;
    border-bottom: 1px solid #dbdbdb;
    vertical-align: middle;
    font-size: 14px;
    color: #222;
  }
  .action-status-col {
    background: #f7f7f8 !important;
    font-weight: 500;
    color: #333;
    border-right: 1px solid #dbdbdb;
  }
  .ant-table-tbody > tr:last-child > td { border-bottom: none; }
  .ant-table-cell { border-right: 1px solid #dbdbdb; }
  .ant-table-cell:last-child { border-right: none; }
  .ant-table-tbody > tr:hover > td { background: #fafafa !important; }
  .ant-input, .ant-input-affix-wrapper, .ant-select-selector, .ant-picker {
    border-radius: 4px !important;
    font-size: 14px;
  }
  .ant-input[disabled], .ant-select-disabled .ant-select-selector {
    background: #f5f5f5 !important;
    color: #555 !important;
    cursor: not-allowed;
  }
`;

const StyledActionBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 18px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  transition: opacity 0.15s;
  background: ${({ $primary }) => ($primary ? "#00685F" : "#e8e8e8")};
  color: ${({ $primary }) => ($primary ? "#ffffff" : "#333")};
`;

const FooterBar = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 40px;
  padding: 14px 32px;
  background: #ffffff;
  border-top: 1px solid #e8e8e8;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.06);
  margin-top: auto;
`;

const FooterBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 22px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
  border: ${({ $primary }) => ($primary ? "none" : "1px solid #000000")};
  background: ${({ $primary }) => ($primary ? "#c2fae5" : "#ffffff")};
  color: ${({ $primary }) => ($primary ? "#131111" : "#000000")};
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;